exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-examples{margin-left:35px;margin-top:20px}.search-examples__item{margin:5px 0}.search-examples__link{color:#959595;font-size:1.071em;line-height:1.4}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .search-examples__link{color:#fff}}:root[data-theme=dark] .search-examples__link{color:#fff}.search-examples__link:hover{border-bottom:1px solid}\n", ""]);

// exports
exports.locals = {
	"search-examples": "search-examples",
	"search-examples__item": "search-examples__item",
	"search-examples__link": "search-examples__link"
};